import isInpostDelivery from '../isInpostDelivery/isInpostDelivery';
import isNextDayDelivery from '../isNextDayDelivery/isNextDayDelivery';

const mapNextDayDeliveryOption = ({
  isDataQa,
  isGB,
  nextDayOption,
  deliveryDate,
  shippingAddress,
}) => {
  // For UK: check if delivery date is truly "next day" (CurrentDate() + 1)
  // Applies to home, shop, and store (FAL-2234 / NIN-1286)
  if (isGB && nextDayOption) {
    if (shippingAddress?.isBfpo) {
      return isDataQa ? 'express-express' : 'Express';
    }

    // Inpost does not offer next day — always Fastest
    const isInpost = isInpostDelivery({
      deliveryDetailKey: nextDayOption?.deliveryDetails?.[0]?.key,
      carrierCode: nextDayOption?.carrierCode,
      shippingAddress,
    });

    if (isInpost || !isNextDayDelivery(deliveryDate)) {
      return isDataQa ? 'express-fastest' : 'Fastest';
    }

    return isDataQa ? 'express-nextDay' : 'Next day';
  }

  return isDataQa ? 'express-express' : 'Express';
};

export default mapNextDayDeliveryOption;
